module.exports = __webpack_public_path__ + "img/Mars.59403241.png";